define('viewModels/privileged/composer/forms/qualityScore/EvaluationScore',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'viewModels/privileged/composer/forms/qualityScore/QuestionGroupScore',
    'viewModels/privileged/composer/vmUtils'
], function (
    ko,
    _,
    ViewModel,
    QuestionGroupScoreViewModel,
    utils
) {
    "use strict";

    var EvaluationScoreViewModel = ViewModel.extend(function EvaluationScoreVm_init(evaluationScoreModel, isShowingDetails, formEditorState) {
        var self = this;

        // Returns the underlying model; used by the editor to save
        self.getModel = function () {
            return evaluationScoreModel;
        };

        // Model Properties
        self.id = evaluationScoreModel.formId;
        self.name = evaluationScoreModel.formName;
        self.modelId = evaluationScoreModel.modelId;
        self.totalScore = evaluationScoreModel.totalScore;
        self.totalCriticalScore = evaluationScoreModel.totalCriticalScore;
        self.anyFailedKillQuestions = evaluationScoreModel.anyFailedKillQuestions;

        // The question groups associated with this evaluation
        self.questionGroupScores = utils.subviewList(self, evaluationScoreModel.questionGroupScores, QuestionGroupScoreViewModel);

        //Adds isPreviewMode, isEditMode, isEvaluatorActionMode, etc.
        _.extend(self, formEditorState.modes);

        // Flag to determine if the evaluation score board should be displaying details
        self.isShowingDetails = isShowingDetails;

        // Triggered by clicking on the evaluation Score Board
        self.toggleShowingDetails = function () {
            self.isShowingDetails(!self.isShowingDetails());
        };

    });
    return EvaluationScoreViewModel;
});

